import { EstateDesignType } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  DesignVariant,
  designVariantsSelector,
  setSelectedDesignVariant,
} from "@/domains/estate/slice";
import EstateDesignVariantList from "@/domains/estate/components/design/EstateDesignVariantList";

export default function EstateDesignListContainer({ type }: { type: EstateDesignType }) {
  const designVariants = useAppSelector((state) => designVariantsSelector(state, type));
  const dispatch = useAppDispatch();

  const onSelect = useCallback(
    (designVariant: DesignVariant) => {
      dispatch(setSelectedDesignVariant(designVariant));
    },
    [dispatch],
  );

  return <EstateDesignVariantList designVariants={designVariants} onSelect={onSelect} />;
}
